export default "__VITE_ASSET__CCaCJkjI__"